import { PDFDocument } from 'pdf-lib'
import { encodeToBase64 } from './encrypt'
import { generateUUID } from './uuid'

/**
 * Lock a Book with a special encrypted password
 * @param {Uint8Array} bytes The pdf file in bytes
 * @param {String} bookId The id of the Book
 * @param {String} bookName The title of the Book
 * @returns
 */
export async function encryptBook(bytes, bookId, bookName) {
  const pdfDoc = await PDFDocument.load(bytes)

  const password = encodeToBase64(bookId + bookName)

  pdfDoc.encrypt({
    userPassword: password,
    ownerPassword: password,
    permissions: {
      printing: 'lowResolution',
      modifying: false,
      copying: false,
      annotating: false,
      fillingForms: false,
      contentAccessibility: false,
      documentAssembly: false,
    },
  })

  const modifiedPdfBytes = await pdfDoc.save()
  return modifiedPdfBytes
}

export async function generateNextBookId() {
  return generateUUID()
}
export const getCurrentTimeKey = () => {
  return new Date().toISOString().slice(0, 16)
}